import React, { useEffect, useRef, useState } from 'react'
import Sidebar from '../../Dashboard/Sidebar/Sidebar'
import Loader from '../../../components/Loader/Loader'
import Select from "react-select";
import { Link, useNavigate, useParams } from 'react-router-dom';
import config from '../../../config/config';
import axios from "axios"
import { Badge } from "react-bootstrap";
import { toastError, toastSuccess } from '../../../common/Toast';
import StoreAccountPaymentModal from '../../../components/Modal/StoreAccountPaymentModal';
import EditTax from '../../../components/Modal/EditTax';
import Moment from 'moment';
import FilterModal from "../../../components/Modal/FilterModal";
import { ALREADY_EXIST, ERROR_MESSAGE, SUCCESS_MESSAGE, CUSTOM_SELECT_DROPDOWN_STYLE } from '../../../common/Constant';


export const ManageFormAdjustment = () => {
  let updatedData = [];
  const totalRef = useRef(0);
  const [loading, setLoading] = useState(false)
  const [depositToAccount, setDepositToAccount] = useState([]);
  const token = localStorage.getItem("Token");
  const [statenew, setStateNew] = useState([]);
  const [selectedPriceForSale, setSelectedPriceForSale] = useState(1);
  const [tireObject, setTireObject] = useState([]);
  const [isChangedData, setIsChangedData] = useState(false);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [commonDiscount, setCommonDiscount] = useState(0);
  const [paidAmount, setPaidAmount] = useState("");
  const [dueAmount, setDueAmount] = useState(0);
  const [custoptions, setCustOptions] = useState([]);
  const [selectedDropDownValue, setSelectDropDownValue] = useState(1);
  const [isContentVisible, setIsContentVisible] = useState(true);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [selectedCategoryForSearch, setSelectedCategoryForSearch] =
    useState(null);
  const [itemsDetailsData, setItemsDetailsData] = useState();
  const [validationErrors, setValidationErrors] = useState([]);
  const [checkboxes, setCheckboxes] = useState(0);
  const [taxData, setTaxData] = useState([]);
  const [globalTaxData, setGlobalTaxData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [tableData, setTableData] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [defaultSellingTierPriceList, setDefaultSellingTierPriceList] =
    useState([]);
  const [inventoryadjustment, setInventoryAdjustment] = useState({})
  const [tablepayload, setTablePayload] = useState({})
  const [tablevariation, setTableVariation] = useState({})
  const [listingdata, setListingData] = useState([])

  // console.log("tablepayload", tablepayload)
  // console.log(tablevariation, "iii")

  // console.log("statenew::>>", statenew)

  console.log(inventoryadjustment, "inventoryadjustment")

  const { id } = useParams();
  const navigate = useNavigate()
  const loginUserId = localStorage.getItem("ID");
  // console.log(tablepayload, "kkk")





  useEffect(() => {
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/inventoryquantityfindbyid?id=${id}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        if (id > 0) {


          // console.log(response.data, "qqq")
          // console.log(response.ResponseData.InventoryQuantityAdjustment[0],"aaa")
          setListingData(response.data.ResponseData.InventoryQuantityAdjusmentItem)

        }
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  console.log(listingdata, "vvv")


  const callbackItemGrid = (payload) => {
    // console.log("payload=>", payload); // Loop over each item in the payload array
    payload.forEach((item) => {
      // Find the index of the item in the statenew array that has the same ItemId
      const index = statenew.findIndex(
        (i) => i.VariationId === item.VariationId
      ); // If the item exists in the statenew array, increment the itemquantity by 1
      if (index !== -1) {
        statenew[index].itemquantity += 1;
      } else {
        // Otherwise, add the item with itemquantity 1 to the statenew array
        statenew.push({ ...item, itemquantity: 1 });
      }
    });
    setStateNew(updatedData);
    setStateNew([...statenew]);
    updateTotal(statenew);
  };


  useEffect(() => {
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/inventoryquantityfindbyid?id=${id}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        if (id > 0) {


          // console.log(response.data, "qqq")
          // console.log(response.ResponseData.InventoryQuantityAdjustment[0],"aaa")
          setInventoryAdjustment(response.data.ResponseData)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])


  const callback1 = (payload) => {
    setTablePayload(payload)
  }



  const options = custoptions.map((option) => ({
    value: option.Id,
    label: option.FirstName + " " + option.LastName,
    address: option.Address1,
    email: option.Email,
  }));


  const callbackHandleEditTax = (payload, index) => {
    // console.log("payloaddddddd", payload);
    setTaxData([...taxData, ...payload]);
    if (payload.some((item) => item.type === "globalTax")) {
      setGlobalTaxData(payload);
    }
  };

  const handleCheckboxChange = (e, index) => {
    updatedData = [...statenew];
    updatedData[index] = {
      ...updatedData[index],
      IsChecked: e.target.checked == true ? 1 : 0,
    };
    setStateNew(updatedData);
    setCheckboxes(e.target.checked == true ? 1 : 0);
  };


  const handleChangeInput = (e, val) => {
    // console.log("e",e)
    // setTablePayload({...tablepayload, [val]: e.value})
    if (val == "InventoryAdjusmentAccount") {
      setInventoryAdjustment({ ...inventoryadjustment, "InventoryAdjusmentAccount": e.value })
    } else {
      setInventoryAdjustment({ ...inventoryadjustment, [val]: e.target.value })
    }

    // setInventoryAdjustment.(e.value)

    // setTablePayload({})
  }

  console.log(inventoryadjustment, "sss")










  useEffect(() => {
    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/Roletierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        // console.log(response.data?.ResponseData, "response of tire list")
        setDefaultSellingTierPriceList(response.data?.ResponseData);
      })
      .catch((error) => {
        console.log(error.message);
      });
  }, [selectedPriceForSale]);





  const handleItemsDelete = (index) => {

    const deleteddata=[...listingdata]
    deleteddata.splice(index,1)
    setListingData(deleteddata)

    const newImageUrls = statenew.filter((_, i) => i !== index);
    setStateNew(newImageUrls);
    updatedData = newImageUrls;
    updateTotal(updatedData);
    const updatedErrors = [...validationErrors];
    updatedErrors.splice(index, 1);
    setValidationErrors(updatedErrors);
  };










 


   
  // useEffect(() => {
  //   if (id == undefined) {
  //     setTablePayload({ ID: 0, ItemVariationID: 0, QuantityonHand: "", NewInQuantity: "", ChangeInQuantity: "" })
  //   }
  // }, [])




  const handleQuantityChange = (index, value) => {
   
    const val= parseFloat(Number(value) - Number(listingdata[index].itemquantity)).toFixed(2)
   
   
    const updatedData = [...listingdata];
   
    updatedData[index] = { ...updatedData[index], ChangeInQuantity:val };
    updatedData[index] = { ...updatedData[index], NewInQuantity:Number(value) };
    
    console.log(updatedData, "jjj")
    setListingData(updatedData);
   

  };

  console.log(listingdata, "list")
 


  const handleItemsDetailsData = (itemDetails) => {
    // console.log("itemDetails", itemDetails.ItemId);
    // setItemsDetailsData(itemDetails.ItemId);
    setItemsDetailsData(itemDetails);
  };


  const [drill, setDrill] = useState(false);
  const handleDrillDown = (e) => {
    // console.log("drill", drill);
    drill ? setDrill(false) : setDrill(true);
  };


  console.log(tablepayload, "ttt")


  

  console.log(listingdata, "listingdata")

  const handleSubmit = () => {


    // VariationId
    // ItemId

    const mappeddata=listingdata.map((item)=>{
      return {
      ID: item.ID ? item.ID : 0,
      ItemId: item.ItemId,
      ItemvaraitionId: item.VariationId,
      QuantityonHand: item.itemquantity,
      NewInQuantity: item.NewInQuantity,
      ChangeInQuantity: item.ChangeInQuantity
      }
    })
    console.log(mappeddata, "mappeddata")
    const jsonobj = {};
    jsonobj.inventoryquantityxml = mappeddata;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.accountingBaseUrl}/chartofaccounts/inventoryquantityupsert`,
        {

          xmlinventoryquantity: jsonstring,
          id: id > 0 ? Number(id) : 0,
          adjusmentdate: Moment(inventoryadjustment.AdjusmentDate).format(
            "yyyy-MM-DD"),
          inventoryadjusmentaccount: inventoryadjustment.InventoryAdjusmentAccount,
          refrenceno: inventoryadjustment.Refrenceno,
          memo: inventoryadjustment.Memo,
          loginuserid: loginUserId,

        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID >= 0) {
          toastSuccess(SUCCESS_MESSAGE);
          navigate("/quantity-adjustment")
          // window.history.back();
          // history.goBack();
          // navigate(-1);
          // event.stopPropagation();
          // window.history.back();
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Data" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
        // window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
      });

  }




 

  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     },
  //   }),
  // };


  function calculateTotal(UnitPrice, itemquantity, itemdiscount) {
    if (isNaN(UnitPrice)) {
      UnitPrice = 0;
    }
    if (isNaN(itemquantity)) {
      itemquantity = 0;
    }
    if (isNaN(itemdiscount)) {
      itemdiscount = 0;
    }
    const totalPrice = UnitPrice * itemquantity * (1 - itemdiscount / 100);

    return totalPrice;
  }



  useEffect(() => {
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("ChartOfAccountDropdown", res.data.ResponseData);
        const mappedReceivingItems = res.data.ResponseData.map((item) => {
          const mappedItem = {
            label: item.Name,
            value: item.ID,
            Amount: item.Amount,
          };
          return mappedItem;
        });
        // setStateNew(mappedReceivingItems);
        setDepositToAccount(mappedReceivingItems);
        // return res;
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function updateTotal(updatedData) {
    console.log(updatedData, "==> updatedData 445");
    setIsChangedData(true);
    let newTotalQuantity = 0;
    updatedData.forEach((item) => {
      newTotalQuantity += Number(item.itemquantity);
    });
    setTotalQuantity(newTotalQuantity);
    console.log(newTotalQuantity, "==> newTotalQuantity  work 445");

    let newTotal = 0;
    updatedData.forEach((item, index) => {
      let totalPrice = 0;
      // let UnitPrice = item.UnitPrice;
      // if (isNaN(item.UnitPrice)) {
      //   UnitPrice = 0;
      // }

      let UnitPrice = item.Price;
      if (isNaN(item.Price)) {
        UnitPrice = 0;
      }

      let itemdiscount = item.itemdiscount;
      if (isNaN(item.itemdiscount)) {
        itemdiscount = 0;
      }
      // if (!isNaN(item.UnitPrice) && !isNaN(item.itemdiscount)) {
      //   totalPrice = item.UnitPrice * item.itemquantity * (1 - item.itemdiscount / 100);
      // // }
      // if (!isNaN(UnitPrice) && !isNaN(item.itemdiscount)) {
      //   totalPrice = parseFloat(UnitPrice)  * parseFloat(item.itemquantity) * (1 - parseFloat(itemdiscount) / 100);
      // }

      console.log(selectedPriceForSale, "selectedPriceForSale 445");
      // totalPrice = item.UnitPrice * item.itemquantity * (1 - itemdiscount / 100);
      totalPrice =
        parseFloat(UnitPrice) *
        parseFloat(item.itemquantity) *
        (1 - parseFloat(itemdiscount) / 100);

      console.log(totalPrice, "==> totalPrice  work 445");
      newTotal = parseFloat(newTotal) + parseFloat(totalPrice);
    });
    newTotal = parseFloat(newTotal) - Number(commonDiscount);
    console.log(newTotal, "==> newTotal work 445");

    totalRef.current = newTotal;

    let paymentTotal = newTotal - parseFloat(paidAmount);
    if (isNaN(paymentTotal)) {
      paymentTotal = 0;
    }
    console.log(paymentTotal, "<== paymentTotal  work 445");
    setDueAmount(paymentTotal);
  }


  const handleChange1 = (index, value) => {
    // let val
    // if (Number(tablepayload.QuantityonHand) > 0) {
    //   val = Number(tablepayload.QuantityonHand) + Number(value)
    // }

    // // setTablePayload({...tablepayload, NewInQuantity: parseFloat(val).toFixed(2) })
    // setTablePayload({
    //   NewInQuantity: val > 0 ? parseFloat(val).toFixed(2) : "",
    //   ChangeInQuantity: value,
    //   QuantityonHand: tablepayload.QuantityonHand
    // })

    const val=parseFloat(Number(listingdata[index].itemquantity) + Number(value)).toFixed(2)
    const updatedData = [...listingdata];
    updatedData[index] = { ...updatedData[index], ChangeInQuantity:Number(value) };
    updatedData[index] = { ...updatedData[index], NewInQuantity: val };
    setListingData(updatedData);

   
    // listingdata[index+1]={...listingdata[index+1],NewInQuantity: val }
    // listingdata[index+1]={...listingdata[index+1],ChangeInQuantity: val }
  }





  const callback = (payload) => {
    console.log("callback allData => ", payload);
    setListingData([...payload])
    if (payload != undefined && payload.length > 0) {
      const newItem = { ...payload[0], itemquantity: 1 };
      const existingItemIndex = statenew.findIndex(
        (item) => item.VariationId == newItem.VariationId
      );
      if (existingItemIndex != -1) {
        const existingItem = statenew[existingItemIndex];
        existingItem.itemquantity = existingItem.itemquantity + 1;
        existingItem.Price =
          selectedPriceForSale == undefined
            ? existingItem.UnitPrice
            : selectedPriceForSale === 1
              ? existingItem.UnitPrice
              : selectedPriceForSale === 3
                ? existingItem.RecallPrice
                : tireObject == "Tier1"
                  ? existingItem.Tier1
                  : tireObject == "Tier2"
                    ? existingItem.Tier2
                    : tireObject == "Tier3"
                      ? existingItem.Tier3
                      : tireObject == "Tier4"
                        ? existingItem.Tier4
                        : tireObject == "Tier5"
                          ? existingItem.Tier5
                          : 0;

        existingItem.Total = calculateTotal(
          selectedPriceForSale == undefined
            ? existingItem.UnitPrice
            : selectedPriceForSale === 1
              ? existingItem.UnitPrice
              : selectedPriceForSale === 3
                ? existingItem.RecallPrice
                : tireObject == "Tier1"
                  ? existingItem.Tier1
                  : tireObject == "Tier2"
                    ? existingItem.Tier2
                    : tireObject == "Tier3"
                      ? existingItem.Tier3
                      : tireObject == "Tier4"
                        ? existingItem.Tier4
                        : tireObject == "Tier5"
                          ? existingItem.Tier5
                          : 0,
          // existingItem.UnitPrice,
          existingItem.itemquantity,
          existingItem.itemdiscount
        );
        console.log(
          existingItem.UnitPrice,
          "existingItem.UnitPrice getItem total"
        );
        console.log(
          existingItem.RecallPrice,
          "existingItem.RecallPrice getItem total"
        );
        console.log(existingItem.Total, "existingItem.Total getItem total");

        const updatedDataNew = [...statenew];
        updatedDataNew[existingItemIndex] = existingItem;
        setStateNew(updatedDataNew);
        console.log("updatedData in callback=>", updatedDataNew);
        updatedData = updatedDataNew;
        // console.log("newItem = in callback=>", existingItem);
      } else {
        newItem.Price =
          selectedPriceForSale == undefined
            ? newItem.UnitPrice
            : selectedPriceForSale === 1
              ? newItem.UnitPrice
              : selectedPriceForSale === 3
                ? newItem.RecallPrice
                : tireObject == "Tier1"
                  ? newItem.Tier1
                  : tireObject == "Tier2"
                    ? newItem.Tier2
                    : tireObject == "Tier3"
                      ? newItem.Tier3
                      : tireObject == "Tier4"
                        ? newItem.Tier4
                        : tireObject == "Tier5"
                          ? newItem.Tier5
                          : 0;

        setStateNew([...statenew, newItem]);

        updatedData = statenew.concat(newItem); // add the new item to updatedData
        // console.log("newItem", newItem);
      }
      console.log("newItem ==>", newItem);
      updateTotal(updatedData); // pass updatedData to updateTotal()
    }

    payload = "";
    console.log("allData12", statenew);
  };
  // console.log(inventoryadjustment,"jjj")
  // console.log(inventoryadjustment.AdjusmentDate,"hhhh")
  // console.log(formatDate(inventoryadjustment.AdjusmentDate),"kkk")
  // console.log(inventoryadjustment.Memo, "ppp")


  const callback2 = (payload) => {
    console.log(payload, "xxx")
    setTableVariation({ ...tablevariation, ...payload.selectedOption })
  }


 console.log(listingdata, "listingdata")
 console.log(inventoryadjustment, "Date")
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          {/* <div className="page-header"> */}
          <div className="d-flex flex-row justify-content-between col-md-12 ">
            {/* Customer Drop Down */}
            <div className="p-2 col-md-2 ">
              Adjustment date
              <input
                type="date"
                className="form-control"
                id="PaymentDate"
                name="PaymentDate"

                onChange={(event) =>
                  handleChangeInput(event, "AdjusmentDate")
                }
                value={Moment(inventoryadjustment.AdjusmentDate).format("YYYY-MM-DD")}
              />
            </div>
            {/* {inventoryadjustment.AdjusmentDate} */}
            {/* InvoiceNumber */}
            <div className="p-2 col-md-2 ">
              Reference No
              <input
                type="number"
                className="form-control"
                placeholder="Enter No"
                name="Reference No"
                defaultValue={inventoryadjustment.Refrenceno}
                onChange={(event) =>
                  handleChangeInput(event, "Refrenceno")
                }
              ></input>
            </div>
            {/* Find */}


          </div>


          <div className='d-flex flex-row col-md-12'>
            <div className="p-2 col-md-3 ">
              Inventory Adjustment Account
              <Select
                // options={depositToOption}
                value={depositToAccount.find((item) => item.value == inventoryadjustment.InventoryAdjusmentAccount)}
                options={depositToAccount}
                placeholder="Select a Account"
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                hideSelectedOptions={true}
                isClearable={true}
                styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                id="DepositTo"
                name="DepositTo"
                onChange={(event) => handleChangeInput(event, "InventoryAdjusmentAccount")}
              />
            </div>
          </div>


          <div className="d-flex flex-column-reverse mb-3">
            <div className="p-2 col-md-3">
              Memo:
              <textarea
                className="form-control"
                name="Memo"
                placeholder="Note"
                defaultValue={inventoryadjustment.Memo}
                style={{ width: "410px", height: "150px" }}
                onChange={(event) => handleChangeInput(event, "Memo")}
              ></textarea>
            </div>

          </div>
          {/* </div> */}



          {/* Receive Payment Table Card */}
          {/* <div className="card"> */}
          {/* <div className="card-body"> */}

          <div className="card col-md-12">
            <div className="card-body">

              <div className="d-flex flex-row mt-2">
                <div className="p-2 col-md-8">
                  <React.Fragment>

                    <SearchableDropdown
                      callback2={callback2}
                      callback1={callback1}
                      listingdata={listingdata}
                      callback={callback}
                      options={options}
                    />
                  </React.Fragment>
                </div>
                <div className="p-2 col-md-2">
                  <Link
                    type="button"
                    className="btn btn-outline-primary w-100"
                    data-bs-target="#exampleModal"
                    data-bs-toggle="modal"
                  >
                    <i className="fa fa-filter me-1"></i> Item Grid
                  </Link>
                </div>

              </div>




              <div className="row">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <table
                      className="table table-striped custom-table"
                      style={{ width: "1024px" }}
                    >
                      <thead>
                        <tr>
                          {drill ? (
                            <th
                              style={{ width: "50px" }}
                              onClick={(e) => handleDrillDown(e)}
                            >
                              <i class="fa fa-minus"></i> No.
                              {/* <button
                                    className="btn btn-outline-primary text-dark "
                                    style={{ border: "none" }}
                                    onClick={(e) => handleDrillDown(e)}
                                  >
                                    -No.
                                  </button> */}
                            </th>
                          ) : (
                            <th
                              style={{ width: "50px" }}
                              onClick={(e) => handleDrillDown(e)}
                            >
                              <i class="fa fa-plus"></i> No.
                              {/* <button
                                    style={{ border: "none" }}
                                    className="btn btn-outline-primary text-dark"
                                    onClick={(e) => handleDrillDown(e)}
                                  >
                                    +No.
                                  </button> */}
                            </th>
                          )}
                          {/* {drill ==true &&(<th><button onClick={(e) => handleDrillDown(e)}>+</button></th>)} */}
                          {/* <th style={{ width: "10px" }}>No.</th> */}
                          <th style={{ width: "100px" }}>Item Name</th>
                          {selectedDropDownValue === 4 && (
                            <th style={{ width: "250px" }}>
                              Payment Amount
                            </th>
                          )}
                          {selectedDropDownValue != 4 && (
                            <>
                              <th
                                style={{ width: "70px" }}
                                className="col-md-2"
                              >
                                Price
                              </th>
                              <th
                                style={{ width: "10px" }}
                                className="col-md-1"
                              >
                                Quantity on hand
                              </th>
                              {(selectedPriceForSale == 1 ||
                                selectedPriceForSale == "" ||
                                selectedPriceForSale == null) && (
                                  <th
                                    style={{ width: "10px" }}
                                    className="col-md-1"
                                  >
                                    New In Quantity
                                  </th>
                                )}
                              <th style={{ width: "50px" }}>Change In Quantity</th>
                              <th style={{ width: "50px" }}>Delete</th>
                              <th
                                style={{ width: "50px" }}
                                className="text-center"
                              >
                                {isContentVisible && (
                                  <input
                                    className="form-check-input form-control"
                                    // style={{ width: "1.5em", height: "1.5em", }}
                                    type="checkbox"
                                    name="CheckBox"
                                    id="CheckBox"
                                    onChange={(e) => {
                                      const checkboxes =
                                        document.querySelectorAll(
                                          'tbody input[type="checkbox"]'
                                        );
                                      checkboxes.forEach((checkbox) => {
                                        checkbox.checked = e.target.checked;
                                      });
                                    }}
                                  />
                                )}
                              </th>
                            </>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {selectedDropDownValue === 4 && (
                          <tr>
                            <td>1</td>
                            <td>
                              <Link
                                type="button"
                                data-bs-target="#StoreAccountPaymentModal"
                                data-bs-toggle="modal"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                Customer Account
                              </Link>

                              <StoreAccountPaymentModal />
                            </td>
                            <td>
                              <input
                                id="paymentamount"
                                name="paymentamount"
                                // type="number"
                                className="form-control"
                                value={paymentAmount}
                                onChange={(e) =>
                                  setPaymentAmount(e.target.value)
                                }
                              />
                            </td>
                          </tr>
                        )}
                        {selectedDropDownValue != 4 &&
                          listingdata.map((item, index) => {
                            console.log("item.ChangeInQuantity",item.ChangeInQuantity)
                              const filteredIndex = statenew.indexOf(item);
                              return (
                                <>
                                  <tr key={item.modifyid}>
                                    <td>{index + 1}</td>
                                    {/* <td></td> */}
                                    <td>
                                      <Link
                                        type="button"
                                        onClick={(e) =>
                                          handleItemsDetailsData(item)
                                        }
                                        data-bs-target="#ItemsDetailsModal"
                                        data-bs-toggle="modal"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {item.ItemName
                                          ? item.ItemName
                                          : item.VariationName}
                                        {/* ({item.VariationName}) */}
                                      </Link>
                                    </td>

                                    <td>

                                      {item.UnitPrice}


                                    </td>

                                    <td>
                                      <input
                                        type="number"
                                        value={item.itemquantity
                                        }
                                        // defaultValue={
                                        //   item.itemquantity
                                        //     ? item.itemquantity
                                        //     : 0
                                        // }
                                        className="form-control"
                                        min={0}
                                        max={item.ItemCurrentQuantity}
                                        // onChange={(e) =>
                                        //   handleQuanChange(
                                        //     filteredIndex,
                                        //     e.target.value
                                        //   )
                                        // }
                                      />
                                      {validationErrors[filteredIndex] && (
                                        <p className="text-danger">
                                          {validationErrors[filteredIndex]}
                                        </p>
                                      )}
                                    </td>

                                    {/* value={entireSaleDiscount}
                            onChange={handleEntireSaleDiscountChange} */}
                                    {(selectedPriceForSale == 1 ||
                                      selectedPriceForSale == "" ||
                                      selectedPriceForSale == null) && (
                                        <td>
                                          <input
                                            type="number"
                                            value={item.NewInQuantity}
                                            // defaultValue={
                                            //   item.itemdiscount
                                            //     // ? item.itemdiscount
                                            //     // : 0
                                            // }
                                            className="form-control"
                                            onChange={(e) =>
                                              handleQuantityChange(
                                                index,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </td>
                                      )}
                                    <td>
                                      <input
                                        type="number"
                                        // value={calculateTotal(item.UnitPrice, item.itemquantity, item.itemdiscount)}
                                        value={item.ChangeInQuantity}                                        
                                        className="form-control"
                                        onChange={(e) =>
                                          handleChange1(
                                            index,
                                            e.target.value
                                          )
                                        }
                                      />
                                      {/* {calculateTotal(item.UnitPrice, item.itemquantity, item.itemdiscount)} */}
                                    </td>

                                    <td className="text-center">
                                      <Link
                                        className="confirm-text"
                                        title="Delete"
                                        style={{ fontSize: "12px" }}
                                        onClick={() =>
                                          handleItemsDelete(index)
                                        }
                                      >
                                        <i
                                          className="fa fa-trash text-red fa-2x"
                                          data-bs-toggle="tooltip"
                                          title="Delete"
                                        ></i>
                                      </Link>
                                    </td>
                                    <td className="text-center">
                                      {isContentVisible && (
                                        <input
                                          className="form-check-input form-control"
                                          // style={{ width: "1.5em", height: "1.5em", }}
                                          type="checkbox"
                                          name={`CheckBox${index}`}
                                          id={`CheckBox${index}`}
                                          defaultChecked={item.Ischecked}
                                          onChange={(e) =>
                                            handleCheckboxChange(e, index)
                                          }
                                        />
                                      )}
                                    </td>
                                  </tr>

                                  {drill && (
                                    <tr>
                                      <td colSpan={8}>
                                        <span className="m-2"></span>
                                        <span className="m-2">
                                          Category: {item.CategoryName}
                                        </span>
                                        <span className="m-2">
                                          UPC/EAN/ISBN: {item.Itemnumber}{" "}
                                        </span>
                                        {/* <span className="m-2">Cost: {item.CostPrice}</span> */}
                                        <span className="m-2">
                                          Stock: {item.ItemCurrentQuantity}
                                        </span>
                                        <span className="m-2">
                                          Tax:{" "}
                                          <Link
                                            type="button"
                                            // data-bs-target="#EditModal"
                                            data-bs-target={`#EditModal-${item.VariationId}`}
                                            data-bs-toggle="modal"
                                            style={{ alignItems: "center" }}
                                          >
                                            Edit Taxes
                                          </Link>
                                        </span>

                                        <EditTax
                                          callback={callbackHandleEditTax}
                                          index={index}
                                          VariationID={item.VariationId}
                                          ItemID={item.ItemId}
                                        />
                                      </td>
                                    </tr>
                                  )}
                                </>
                              );
                            })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>


            </div>

          </div>


           {/* <div class="pull-right">
          <div ><button onClick={handleSubmit} class="btn btn-primary pull-right mb-3">Save</button></div>
          <div>
            <button onClick={()=>navigate(-1)} class="btn btn-secondary mb-3">Cancel</button>
         
         </div>
        </div> */}




        
                                        <div className="pull-right ">
                                          <button

                                            onClick={handleSubmit}

                                            className="btn btn-primary pull-right mb-3"

                                            

                                          >

                                            Save

                                          </button>
                                          <div

                                            onClick={()=>navigate(-1)}
                                            className="btn btn-secondary mb-3 "
                                          >
                                            Cancel
                                          </div>
                                        </div>





        </div>
        </div>


      

      <FilterModal callback={callbackItemGrid} />
    </>
  )
}



const SearchableDropdown = ({
  
  callback2,
  listingdata,
  callback,
  disabled,
  readonly,
}) => {

  // console.log(customerID, "<===customerId 1155")
  const token = localStorage.getItem("Token");
  const locationID = localStorage.getItem("Location");
  //const Clone = localStorage.getItem("Clone");
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [tableData, setTableData] = useState([]);

  const [variationdata, setVariationData] = useState({})
  // const [condition,setCondition]=useState(false)

  

  console.log(tableData, "qqq")


  // useEffect(()=>{
  //      axios
  //     .get(
  //       `${
  //         config.accountingBaseUrl
  //       }/chartofaccounts/inventoryquantityfindbyid?id=1`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       if (response.data.ResponseData.length > 0) {
  //         if (response != "" && response != null) {
  //           const data = response.data.ResponseData;

  //           console.log("suggestions ==>", suggestions);
  //           // console.log("Search Details ===>", data);

  //           if (data[0].ItemId > 0) {
  //             setSuggestions(data);
  //           }
  //         }
  //       }
  //     })
  //     .catch((error) => {});
  // },[])


  const fetchData = async () => {
    if (inputValue != "") {
      setSuggestions([]);



      await axios
        .get(
          `${config.itemsBaseUrl
          }/items/searchforaccount?searchparam=${inputValue}&iscategory=${0}&customerid=&supplierid=${0}&locationid=${locationID}&isservice=${1}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (response.data.ResponseData.length > 0) {
            if (response != "" && response != null) {
              const data = response.data.ResponseData;

              console.log("suggestions ==>", suggestions);
              // console.log("Search Details ===>", data);

              if (data[0].ItemId > 0) {
                setSuggestions(data);
              }
            }
          }
        })
        .catch((error) => { });
    } else {
      setSuggestions([]);
    }
  };


  useEffect(() => {
    // fetchData();

    const timer = setTimeout(() => {
      if (inputValue) {
        // Make your API call here
        fetchData();
      }
    }, 500); // Adjust the delay according to your needs (in milliseconds)

    return () => {
      clearTimeout(timer);
    };
  }, [inputValue]);

  // Fetch data from an API


  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);
    if (!value) {
      setSuggestions([]);
    }
  };

  const handleToast = () => {
    if (readonly === true) {
      toastError("Please Select a Customer First");
    }
  };

  const handleInputClick = (
    pItemId,
    pItemName,
    pVariationName,
    pUnitPrice,
    pItemQuantity,
    pDescription,
    pVariationId,
    pAttributeId,
    pModule,
    pCategoryID,
    pCategoryName,
    pCostPrice,
    pItemnumber,
    pAllowaltdescription,
    pIsItemserialnumber,
    pVariationQuantity,
    pRecallPrice,
    pTier1,
    pTier2,
    pTier3,
    pTier4,
    pTier5
                                 
    // pItemKitId
  ) => {

    if (pModule == "ItemKit") {
      axios
        .get(
          `${config.itemKitsBaseUrl}/itemkits/itemkitsitemslisting?itemkitid=${pItemId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (response != "" && response != null) {
            const data = response.data.ResponseData;
            console.log(data, "vvv")
            setSuggestions(data, () => { });

            let tablesDatas = data.map((item) => ({
              SaleItemID: 0,
              ItemId: item.ItemId,
              SaleId: 0,
              UnitPrice: item.UnitPrice,
              // Price: item.UnitPrice, 
              ItemName: item.ItemName,
              VariationName: item.VariationName,
              itemquantity: 1,
              ItemCurrentQuantity: item.VariationQuantity, // item.Itemquantity,
              itemdiscount: 0,
              Description: item.Description,
              VariationId: item.VariationId,
              AttributeId: item.AttributeId,
              Module: item.Module,
              Itemkitid: item.Itemkitid,
              CategoryID: item.CategoryID,
              CategoryName: item.CategoryName,
              CostPrice: item.CostPrice,
              Itemnumber: item.Itemnumber,
              Total: item.UnitPrice,
              Allowaltdescription: item.Allowaltdescription,
              IsItemserialnumber: item.IsItemserialnumber,
              RecallPrice: item.RecallPrice,
              Tier1: item.Tier1,
              Tier2: item.Tier2,
              Tier3: item.Tier3,
              Tier4: item.Tier4,
              Tier5: item.Tier5,
            }));

            setTableData([tablesDatas[0]]);
            setVariationData({ ...variationdata, ...tablesDatas[0] })
            setSuggestions([]);
          }
        })
        .catch((error) => { });
    } else {
      const selectedOption = {
        SaleItemID: 0,
        ItemId: pItemId,
        SaleId: 0,
        UnitPrice: pUnitPrice,
        // Price: pUnitPrice,
        ItemName: pItemName,
        VariationName: pVariationName,
        itemquantity: 1,
        ItemCurrentQuantity: pVariationQuantity, //pItemQuantity,
        itemdiscount: 0,
        Description: pDescription,
        VariationId: pVariationId,
        AttributeId: pAttributeId,
        Module: pModule,
        // NewInQuantity:0,
        // ChangeInQuantity:0,
        Itemkitid: 0,
        CategoryID: pCategoryID,
        CategoryName: pCategoryName,
        CostPrice: pCostPrice,
        Itemnumber: pItemnumber,
        Total: pUnitPrice,
        Allowaltdescription: pAllowaltdescription,
        IsItemserialnumber: pIsItemserialnumber,
        RecallPrice: pRecallPrice,
        Tier1: pTier1,
        Tier2: pTier2,
        Tier3: pTier3,
        Tier4: pTier4,
        Tier5: pTier5,
        // ItemKitId: pItemId
      };
      console.log(selectedOption, "selectedOption 112233")
      setSuggestions([selectedOption]);
      setVariationData({ ...variationdata, selectedOption })
      setTableData([...listingdata, selectedOption]);
    }

    setInputValue("");
    setSuggestions([]);
  };


  useEffect(() => {
    callback2(variationdata)
  }, [variationdata])


  // useEffect(()=>{
  //  callback1(listingdata)
  // },[listingdata])

  useEffect(() => {
    const locationItemData = tableData?.filter((locationItem) => {
      return locationItem.ItemId !== "";
    });

    callback(locationItemData);
  }, [tableData]);

  // function calculateItemTax(total, taxPercent, stateLength) {
  //   return (total * taxPercent) / 100 / stateLength;
  // }

  // function calculateOtherTax(total, taxPercent, stateLength, taxXml) {
  //   const uniqueTaxItemIds = [...new Set(taxXml.map((item) => item.TaxItemId))];
  //   const uniqueTaxItemCount = uniqueTaxItemIds.length;
  //   return (total * taxPercent) / 100 / (stateLength - uniqueTaxItemCount);
  // }

  // function calculateTax{
  //   let taxAmount = 0;

  //   // if (tax.type === "itemTax") {
  //   //   taxAmount = (totalRef.current * tax.TaxPercent) / 100 / statenew.length;
  //   // } else {
  //   //   const uniqueTaxItemIds = [
  //   //     ...new Set(taxXml.map((item) => item.TaxItemId)),
  //   //   ];
  //   //   const nonDuplicateStatesCount = statenew.length - uniqueTaxItemIds.length;
  //   //   taxAmount =
  //   //     (totalRef.current * tax.TaxPercent) / 100 / nonDuplicateStatesCount;
  //   // }

  //   return taxAmount;
  // };
  console.log(suggestions, "<========suggestions");
  console.log(tableData, "tableData")

  return (
    <div className="">
      <form>
        <div className="">
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              <Link to="/manage-items">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fillRule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  />
                </svg>
              </Link>
            </span>

            <input
              type="text"
              className="form-control"
              placeholder="Type item name or scan barcode"
              value={inputValue}
              onChange={handleInputChange}
              onClick={handleToast}
              disabled={disabled}
              readOnly={readonly}
            />
          </div>
        </div>
        {suggestions.length > 0 ? (
          <div className="dropdown">
            <ul
              className="dropdown-menu w-100 show"
              style={{ "max-height": "500px", overflow: "auto" }}
            >
              {suggestions.map((item) => (
                <li
                  className="border-bottom"
                  key={item.ItemId}
                  onClick={() =>
                    handleInputClick(
                      item.ItemId,
                      item.ItemName,
                      item.VariationName,
                      item.UnitPrice,
                      item.Itemquantity,
                      item.Description,
                      item.VariationId,
                      item.AttributeId,
                      item.Module,
                      item.CategoryID,
                      item.CategoryName,
                      item.CostPrice,
                      item.Itemnumber,
                      item.Allowaltdescription,
                      item.IsItemserialnumber,
                      item.VariationQuantity,
                      item.RecallPrice,
                      item.Tier1,
                      item.Tier2,
                      item.Tier3,
                      item.Tier4,
                      item.Tier5

                      // item.ItemKitId
                    )
                  }
                >
                  <Link
                    key={item.ItemId}
                    href="#"
                    className="dropdown-item"
                    data-name={item.ItemName?.toLowerCase()}
                  >
                    <img
                      src={item.ImageName}
                      onError={(e) => {
                        e.currentTarget.src =
                          "https://th.bing.com/th/id/OIP.ADcGkW6WTfq2zu8yoY8vlgHaHa?w=197&h=197&c=7&r=0&o=5&pid=1.7";
                      }}
                      alt={item.ItemName}
                      className="img-thumbnail rounded-circle m-2"
                      width="55px"
                      height="55px"
                    />
                    <div className="customer-info">
                      <h6 className="name">
                        {item.ItemName}{" "}
                        {item.VariationName ? `(${item.VariationName})` : ""}
                        <Badge
                          className="ml-auto"
                          variant="primary"
                          style={{ position: "absolute", right: "5px" }}
                        >
                          {item.Module}
                        </Badge>
                      </h6>
                      <div>
                        {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)} |
                          Promo Price: {parseFloat(item.PromoPrice).toFixed(2)}| */}
                        {/* Unit Price: {parseFloat(item.UnitPrice).toFixed(2)} | Qty: {parseInt(item.Itemquantity)} */}
                        Unit Price: {parseFloat(item.UnitPrice).toFixed(2)} |
                        Qty: {parseInt(item.VariationQuantity)}
                      </div>
                      <div>Categories: {item.CategoryName}</div>
                      {/* Add any other customer details here */}
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </form>
    </div>
  );
};
